import { css } from '@emotion/css'
import { spacing, shorthandHelper } from '@offerzen/pinata'

const styles = {
  workExperience: css({
    display: 'flex',
    alignItems: 'center',
    padding: shorthandHelper([spacing.medium, spacing.large, 0, 0]),

    // Override existing styles
    label: {
      marginBottom: 0,
    },
  }),

  notice: css({
    marginTop: spacing.medium,
  }),

  footer: css({
    marginTop: spacing.large,
  }),
}

export default styles
